import { useState } from 'react';
import { trpc } from '../lib/trpc';
import { useAuth } from '../hooks/useAuth';

export const VerificationBanner = () => {
  const { user } = useAuth();
  const [isDismissed, setIsDismissed] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const resendMutation = trpc.auth.resendVerification.useMutation({
    onSuccess: () => {
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 5000);
    },
  });

  // Don't show banner if user is verified, not logged in, or has dismissed it
  if (!user || user.emailVerified || isDismissed) {
    return null;
  }

  const handleResend = () => {
    if (user.email) {
      resendMutation.mutate({ email: user.email });
    }
  };

  return (
    <div className="bg-yellow-50 border-b border-yellow-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div className="flex items-center gap-3 flex-1">
            <svg
              className="h-5 w-5 text-yellow-600 flex-shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
            <div className="flex-1">
              <p className="text-sm text-yellow-800">
                <span className="font-medium">Verify your email to unlock all features.</span>
                {' '}
                Check your inbox for a verification link or{' '}
                <button
                  onClick={handleResend}
                  disabled={resendMutation.isPending}
                  className="font-medium underline hover:text-yellow-900 cursor-pointer bg-transparent border-none p-0"
                >
                  {resendMutation.isPending ? 'Sending...' : 'resend verification email'}
                </button>
                .
              </p>
              {showSuccess && (
                <p className="text-sm text-green-700 mt-1">
                  ✓ Verification email sent! Check your inbox.
                </p>
              )}
              {resendMutation.isError && (
                <p className="text-sm text-red-700 mt-1">
                  Failed to send verification email. Please try again later.
                </p>
              )}
            </div>
          </div>
          <button
            onClick={() => setIsDismissed(true)}
            className="flex-shrink-0 p-1 rounded-md text-yellow-600 hover:bg-yellow-100 cursor-pointer bg-transparent border-none"
            aria-label="Dismiss"
          >
            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};
